/* eslint-disable no-console */

export const logError = (...rest: Parameters<typeof console.error>) => {
  return console.error(...rest);
};
